<template>
  <MaskLayer>
    <!-- te-popup begin -->
    <div class="te-alert d-flex flex-column">
      <a
        v-if="haveClose"
        href="javascript:void(0)"
        aria-label="Close"
        class="close"
        style="z-index: 10"
        @click="$emit('close')"
      >
        <i class="material-icons">close</i>
      </a>
      <div class="content d-flex align-items-center flex-column flex-grow-1">
        <slot />
      </div>
      <div class="alert-btn">
        <button
          v-if="haveCancel"
          class="mx-1 btn btn-sm btn-light rounded-pill"
          @click="$emit('close')"
        >
          <span class="px-3">{{ cancelWording }}</span>
        </button>
        <button
          v-if="haveConfirm"
          class="mx-1 btn btn-sm btn-primary rounded-pill"
          :style="{
            background: 'rgba(' + themeColor + ', 1)',
            'border-color': 'rgba(' + themeColor + ', 1)',
          }"
          @click="$emit('confirm')"
        >
          <span class="px-3">{{ confirmWording }}</span>
        </button>
      </div>
    </div>
  </MaskLayer>

  <!-- te-popup end -->
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';
import i18n from '@/locales/i18n';

export default {
  components: {
    MaskLayer,
  },
  props: {
    haveConfirm: {
      type: Boolean,
      default: true,
    },
    haveCancel: {
      type: Boolean,
      default: true,
    },
    haveClose: {
      type: Boolean,
      default: true,
    },
    confirmWording: {
      type: String,
      default: i18n.t('global.confirm'),
    },
    cancelWording: {
      type: String,
      default: i18n.t('global.cancel'),
    },
    themeColor: {
      type: String,
    },
  },
};
</script>
